<template>
  <el-card class="box-card mb-50 notice-box">
    <table-notice
      :data="data"
      @change-page="handleChangePage"
      :loading="loading"
      @redirect-detail="redirectDetail"
      :hasCreate="(site === $siteType.site_partner) ? false : true"
      @handle-redirect-create="redirectCreate"
    >
    </table-notice>
  </el-card>
</template>
<script>
  import { getListPartnerNotice } from '../../../api/notice'

  export default {
    props: {
      site: { type: Number, required: false },
    },

    data() {
      return {
        data: {},
        loading: true,
        sortProp: {key: 'created_at', dir: 'descending'}
      }
    },

    methods: {
      getListData(page=1) {
        getListPartnerNotice(page, this.sortProp)
        .then(response => response.json())
        .then(response => {
          this.data = response.data;
          this.loading = false;
        })
        .catch((error) => {
        })
      },

      handleChangePage(page) {
        this.loading = true;
        this.getListData(page);
      },

      redirectDetail(id) {
        const url = (this.site == this.$siteType.site_partner) ? `/notices/${id}` : `/notices/partner/${id}`;
        window.location.href = url;
      },

      redirectCreate() {
        window.location.href = "/notices/partner/create";
      }
    },

    created() {
      this.getListData();
    },
  }
</script>
